import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { FormProvider } from "./Context/FormContext";
import { hydrate, render } from "react-dom";
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <FormProvider>
//     <App />
//   </FormProvider>
// );
const rootElement = document.getElementById("root");
const app = (
  <FormProvider>
    <App />
  </FormProvider>
);
// Compatibility with react-snap (requires these deprecated APIs)
if (rootElement.hasChildNodes()) {
  hydrate(app, rootElement);
} else {
  render(app, rootElement);
}

reportWebVitals();
